<mat-toolbar color="accent">
  <mat-toolbar-row>
    <span>
      {{ subTitle }}
    </span>
    <span class="spacer"></span>
    <button mat-raised-button type="button" aria-label="Edit" (click)="handleBack()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button mat-raised-button type="button" aria-label="Edit" (click)="handleEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<div class="field-container" *ngIf="isLoaded">
	<div class="field-item field-full field-sm-half field-md-quarter">
    <label>Code ID</label>
    <span>{{code.code_id}}</span>
  </div>
  <div class="field-item field-full field-sm-half field-md-quarter">
    <label>Code</label>
    <span>{{code.code}}</span>
  </div>
  <div class="field-item field-full field-sm-half field-md-quarter">
    <label>Type</label>
    <span>{{code.code_type}}</span>
  </div>
  <div class="field-item field-full field-sm-half field-md-quarter">
    <label>Order</label>
    <span>{{code.code_order}}</span>
  </div>
  <div class="field-item field-full">
    <label>Decription</label>
    <span>{{code.description}}</span>
  </div>
  <div class="field-item field-full">
    <label>Decription (Long)</label>
    <span>{{code.description_long}}</span>
  </div>
  <div class="field-item field-full field-sm-half">
    <label>Active?</label>
    <span>{{code.is_active}}</span>
  </div>
  <div class="field-item field-full field-sm-quarter">
    <label>Created</label>
    <span>{{code.updated_at}}</span>
  </div>
  <div class="field-item field-full field-sm-quarter">
    <label>Updated</label>
    <span>{{code.updated_at}}</span>
  </div>
    
</div>